export function translationFactory(globalText) {
   'ngInject';
    return {
        getTranslation: function(text, upperCase) {
            var translation = globalText[text];
            return upperCase === true ? translation.toUpperCase() : translation;
        },
      
    };
}

export default angular.module("mars.vet.pre.services.translation", ["ng"]).factory('TranslationService',translationFactory).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/translation/translation.service.js